import React, { useState, useEffect } from 'react';
import { Snackbar, Button } from '@mui/material';

export default function UpdateNotification() {
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);

  useEffect(() => {
    // Registra un callback per gli aggiornamenti del service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        setShowUpdateNotification(true);
      });
    }
  }, []);

  const handleUpdate = () => {
    window.location.reload();
  };

  return (
    <Snackbar
      open={showUpdateNotification}
      message="Nuova versione disponibile!"
      action={
        <Button color="secondary" size="small" onClick={handleUpdate}>
          AGGIORNA
        </Button>
      }
    />
  );
}